import React from 'react';

import { Button } from '../../../../components/general';

import { Person } from '../../../../types';
import { isEmpty } from '../../../../utils';

import FaceCircle from '../../components/faceCircle';

interface Props {
  people: Person[];
  handleClickPerson: (person: Person, label: string) => void;
  isSelectionMode: boolean;
  selectedPeopleIds: string[];
  onClickCheckbox: (id: string | null, isAddAll?: boolean) => void;
}

const PeopleCompleteBlock: React.FC<Props> = (props) => {
  const {
    people,
    handleClickPerson,
    isSelectionMode,
    selectedPeopleIds,
    onClickCheckbox,
  } = props;

  if (isEmpty(people)) return null;

  return (
    <div className="flex flex-col gap-4">
      {isSelectionMode && (
        <div className="flex gap-2 items-center">
          <div className="font-bold">
            Select people you want to generate videos for
          </div>
          <Button
            onClick={() => onClickCheckbox(null, true)}
            variant="link"
            className="text-sm"
          >
            Select All
          </Button>
          |
          <Button
            onClick={() => onClickCheckbox(null, false)}
            variant="link"
            className="text-sm"
          >
            Deselect All
          </Button>
        </div>
      )}

      <div className="flex flex-row flex-wrap gap-6">
        {people.map((person) => (
          <FaceCircle
            key={person.face.elementId}
            person={person}
            onClick={() => handleClickPerson(person, 'Complete')}
            isSelectionMode={isSelectionMode}
            isSelected={selectedPeopleIds.includes(person.face.elementId)}
            onClickCheckbox={onClickCheckbox}
          />
        ))}
      </div>
    </div>
  );
};

export default PeopleCompleteBlock;
